/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Error = {
  properties: {
    statusCode: {
      type: 'number',
      description: `http status code`,
      isRequired: true,
    },
    message: {
      type: 'string',
      description: `error message`,
      isRequired: true,
    },
  },
} as const;
